'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconDefault = function IconDefault(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement('path', {
			d: 'M7.51 8.022L7.5 8.02l-.011.002-4.607-6.106h9.236L7.51 8.022zm7.349-6.595a.912.912 0 0 0 .079-.167.916.916 0 0 0 .04-.194c.004-.037.022-.07.022-.108 0-.023-.012-.042-.013-.064a.944.944 0 0 0-.04-.197c-.016-.055-.029-.108-.054-.158a.92.92 0 0 0-.111-.163c-.036-.046-.069-.09-.113-.128-.019-.018-.029-.04-.05-.056-.034-.027-.076-.034-.113-.055a.924.924 0 0 0-.159-.075.906.906 0 0 0-.198-.041C14.112.017 14.079 0 14.041 0H.958C.92 0 .887.017.85.021a.906.906 0 0 0-.198.041.88.88 0 0 0-.158.075C.456.158.415.165.38.192.359.208.349.23.33.248.287.286.253.33.217.376.176.429.135.48.107.539.082.589.069.642.052.697a.942.942 0 0 0-.039.197C.011.916 0 .935 0 .958c0 .038.017.071.022.108.007.066.017.13.039.194.02.06.049.113.08.166.019.035.026.075.051.108l6.349 8.414v4.093c0 .527.432.959.959.959a.962.962 0 0 0 .958-.959V9.948l6.349-8.414c.025-.033.032-.073.052-.107z',
			fill: '#3F5060',
			fillRule: 'evenodd'
		})
	);
};

IconDefault.defaultProps = {
	width: '15',
	height: '15',
	viewBox: '0 0 15 15',
	xmlns: 'http://www.w3.org/2000/svg'
};

var Filter = function (_React$Component) {
	_inherits(Filter, _React$Component);

	function Filter() {
		_classCallCheck(this, Filter);

		return _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).apply(this, arguments));
	}

	_createClass(Filter, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(IconDefault, null);
		}
	}]);

	return Filter;
}(_react2.default.Component);

exports.default = Filter;